const baseStyle = (props: Record<string, any>) => ({
  _container: {
    alignItems: props.direction === 'horizontal' ? 'center' : 'flex-start',
    flexBasis: 'auto',
    flexDirection: 'row',
    paddingBottom: 4,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 4,
    width: '100%',
  },
  _content: {
    alignItems: props.direction === 'horizontal' ? 'center' : 'flex-start',
    flex: 1,
    justifyContent: 'space-between',
    marginRight: 3,
  },
  _description: {
    color: 'secondary',
    flexWrap: 'wrap',
    fontSize: 14,
    lineHeight: 22,
  },
  _icon: {
    alignSelf: 'center',
    color: 'gray.900',
    size: 5,
  },
  _title: {
    color: 'primary',
    fontSize: 16,
    fontWeight: 'semibold',
    lineHeight: 24,
  },
});

export default {
  baseStyle,
};
